import { render, staticRenderFns } from "./FolderRenameModal.vue?vue&type=template&id=5ea71dfd&"
import script from "./FolderRenameModal.vue?vue&type=script&lang=ts&"
export * from "./FolderRenameModal.vue?vue&type=script&lang=ts&"
import style0 from "./FolderRenameModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports